import { Lock } from "lucide-react";

// Track is 44 wide with 2px padding around a 20px knob, so the knob slides
// exactly 20px between the two ends. Driven by a transform rather than flex
// justification, which is what makes it animate.
const KNOB_TRAVEL = "translate-x-[20px]";

/**
 * 44x24 pill toggle from the design. Locked rows are always-on: the track stays
 * blue at 40% opacity, carries a padlock and ignores clicks.
 */
const SettingToggle = ({ value, locked = false, onToggle }) => {
  if (locked) {
    return (
      <div className="relative flex h-[24px] w-[44px] shrink-0 items-center rounded-full bg-[#0065FD] p-[2px] opacity-40">
        <Lock className="absolute left-[6px]" size={12} color="#F8F9FE" strokeWidth={2.5} />
        <div className={`h-[20px] w-[20px] rounded-full bg-[#F8F9FE] shadow-[0px_1px_2px_rgba(10,13,18,0.06),0px_1px_3px_rgba(10,13,18,0.10)] ${KNOB_TRAVEL}`} />
      </div>
    );
  }

  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!value}
      onClick={onToggle}
      className={`flex h-[24px] w-[44px] shrink-0 items-center rounded-full p-[2px] transition-colors duration-200 ease-out ${
        value ? "bg-[#0065FD]" : "bg-[#D6DCE9]"
      }`}
    >
      <div
        className={`h-[20px] w-[20px] rounded-full bg-white shadow-[0px_1px_2px_rgba(10,13,18,0.06),0px_1px_3px_rgba(10,13,18,0.10)] transition-transform duration-200 ease-out ${
          value ? KNOB_TRAVEL : "translate-x-0"
        }`}
      />
    </button>
  );
};

export default SettingToggle;
